export interface GetAllValutazioniFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    from?: Date
    valType?: string
    validationM24User?: string
    validationVisitUser?: string
    to?: Date
}

export interface GetAllValutazioniResponseData {
    id: string
    customerId: string,
    norm: string
    customerCompanyName: string,
    customerRegion: string,
    customerHeadQuarters: string,
    customerClientCode: string,
    M24date: Date
    visitDate: Date
    validationVisitDate: Date
    validationVisitUser: string
    validationType: string
    validationM24User: string
}

export enum ValTypeEnum {
    M24 = 'M24',
    VISITE = 'VISITE',
    VISITE_M24 = 'VISITE_M24',
}